import React, { useEffect } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { 
    renderCreditCard,
    renderHidden,
} from '../Common/FormFields';
import { SCMakePaymentContainer } from '../Payment/css';
import {
    CreditCardAddNew,
    Button,
} from '@payright/web-components';
import { Link } from 'react-router-dom'; 
import { reduxForm } from 'redux-form';
import { handleGoBackToMakePayment, setCurrentSelectedCard } from '../../actions/paymentActions';
import * as CONSTANT from '../../util/constants/messages';
import { isCardExpired } from '../../util/helpers';

let ChangePayment = (props) => {

    const { 
        handleSubmit, 
        paymentMethods, 
        handleAddNewCard,
        selectedCardNumber, 
        setCurrentSelectedCard,
        showMessages,  
        error, 
        submitting, 
        addPaymentMethodSuccess,
        dispatch,
        change,
    } = props;

    const handleCancelClick = () => {
        dispatch(handleGoBackToMakePayment());
    }

    useEffect(() => {
        change('paymentMethodId', selectedCardNumber);
    }, [selectedCardNumber])

    const cardPayments = paymentMethods.filter((method) => method.payment_method_type === 'Card');

    const hasValidCardSelected = () => paymentMethods.some((method: {enabled: boolean, cardExpiry: string}) => method.enabled && !isCardExpired(method.cardExpiry));

    const renderCardList = () => {
        return cardPayments.map((method, i) => {
            const expired = isCardExpired(method.cardExpiry);
            return <div className='payment-method-row' key={i}>
                <Field
                    name="payment-method"
                    label='Make default method' 
                    className='paymentType'
                    defaultValue="default-method"
                    selected={method.enabled}
                    last4Digits={method.cardLastDigits}
                    cardType={method.cardProvider.toLowerCase()}
                    cardExpiry={method.cardExpiry}
                    expired={expired}
                    selectCard={setCurrentSelectedCard(method.id)}

                    component={renderCreditCard} /> 
            </div>;
        })
    }

    return(
        <SCMakePaymentContainer>
            <form  className="addPayment" onSubmit={handleSubmit}>
                <h3 className='page-title'>{ CONSTANT.CHANGE_PAYMENT_METHOD_PAGE_TITLE}</h3>
                <div className="alerts">
                    { showMessages(addPaymentMethodSuccess, error, CONSTANT.CARD_ADDED_SUCCESSFULLY_MESSAGE )}
                </div>
                {renderCardList()}
                <div className='payment-method-row'>
                    <CreditCardAddNew handleClick={handleAddNewCard} />    
                </div>
                <Field 
                    type='hidden'
                    name='paymentMethodId'
                    defaultValue={selectedCardNumber}
                    component={renderHidden}
                />
                <div className='btn-section'>
                    <Link to='#' className='cancel-btn' onClick={() => handleCancelClick()}>Cancel</Link>
                    <Button colour='blue'  type='submit' maxWidth="20%" disabled={submitting || !hasValidCardSelected()}>
                    { submitting ?
                        <>
                            { CONSTANT.SUBMITTING_TEXT }
                        </>
                    :
                        <>
                            { CONSTANT.CONFIRM_BUTTON }
                        </>
                    }
                    </Button>
                </div>
            </form>
        </SCMakePaymentContainer>
    );
}

const mapDispatchToProps = dispatch => ({
    setCurrentSelectedCard: (id) => {
        return () => {
            dispatch(setCurrentSelectedCard(id))
        }
    }
});

const mapStateToProps = state =>  {
    return {
        selectedCard : state.selectedCard,
        addPaymentMethodSuccess: state.loanPayments.addPaymentMethodSuccess,
    };
}

ChangePayment = reduxForm({
	form: 'SelectPaymentMethod',
}) (ChangePayment);

export default connect(mapStateToProps, mapDispatchToProps)(ChangePayment);